// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3TdDl","dragIcon":"SortableItem_dragIcon__3NltB","disabled":"SortableItem_disabled__tIHjv"};